<template>
  <div class="footer-page">
    <van-tabbar v-model="active">
      <van-tabbar-item
        v-for="(item, index) in items"
        :key="index"
        :name="item.key"
        @click="toPage(item)"
      >
        <template #icon="props">
          <svg-icon
            :icon-class="item.key"
            :class="props.active ? 'footer-icon-select' : 'footer-icon'"
          />
        </template>
        <span>{{ item.value }}</span>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>

export default {
  name: "WebFooter",
  data() {
    return {
      active: 'home',
      menukey: 'lockming,exchangeb,loans,staking,changemoney,',
      items: [
        { key: "home", value: this.$t("footer.home") },
        { key: "market", value: this.$t("footer.market") },
        { key: "exchange", value: this.$t("footer.exchange") },
        { key: "options", value: this.$t("footer.options") },
        { key: "lockming", value: this.$t("home.menu7") },
        { key: "exchangeb", value: this.$t("home.menu5") },
        { key: "loans", value: this.$t("home.menu6") },
        { key: "staking", value: this.$t("home.menu8") },
        { key: "changemoney", value: this.$t("footer.change") },
        { key: "assets", value: this.$t("footer.assets") },
      ],
      baseitems:[
        { key: "home", value: this.$t("footer.home") },
        { key: "market", value: this.$t("footer.market") },
        { key: "exchange", value: this.$t("footer.exchange") },
        { key: "options", value: this.$t("footer.options") },
        { key: "lockming", value: this.$t("home.menu7") },
        { key: "exchangeb", value: this.$t("home.menu5") },
        { key: "loans", value: this.$t("home.menu6") },
        { key: "staking", value: this.$t("home.menu8") },
        { key: "changemoney", value: this.$t("footer.change") },
        { key: "assets", value: this.$t("footer.assets") },
      ],
      apidata:[
        { key: "home", value: this.$t("footer.home") },
        { key: "market", value: this.$t("footer.market") },
        { key: "exchange", value: this.$t("footer.exchange") },
        { key: "options", value: this.$t("footer.options") },
        { key: "assets", value: this.$t("footer.assets") },
      ]
    };
  },
  created(){
    this.items = []
    this.apidata.forEach(item => {
      const tmp = this.baseitems.filter(e => e.key == item.key)
      if(tmp && tmp.length > 0){
        this.items.push(tmp[0])
      }
    });
  },
  mounted(){
    this.active = this.$route.name
    if(this.menukey.indexOf(this.active.toLocaleLowerCase()+',')  != -1){
      if(this.items.filter(e => e.key == 'lockming').length > 0){
        this.$emit('hide-header')
      }
    }
  },
  methods: {
    toPage(item) {
      if (item.key !== "home") this.$router.push({ name: item.key }, () => {});
      else this.$router.push({ path: "/" }, () => {});
    },
  },
};
</script>

<style>
</style>
